import langs from './langs.json';

export type SupportedLocale = 'cs' | 'sk' | 'en';
export const DEFAULT_LOCALE: SupportedLocale = 'cs';

export function isSupportedLocale (value: string): value is SupportedLocale {
	return [ 'cs', 'sk', 'en' ].includes(value);
}

export function getSupportedLocale (value: string): SupportedLocale | null {
	if (isSupportedLocale(value)) { return value; }
	return null;
}

export type LanguageInfo = {
	key: string;
	nativeName: string;
	englishName: string;
};

export function getLanguageInfoByIdentifier (identifier: string): LanguageInfo | null {
	const languages: Record<string, { nativeName: string; englishName: string }> = langs;
	const languageInfo = languages[identifier] || null;

	return languageInfo != null
		? { key: identifier, ...languageInfo }
		: null;
}

export type ReleaseNoteLocale = 'cs' | 'en';
export const DEFAULT_RELEASE_NOTE_LOCALE: ReleaseNoteLocale = 'cs';

export function isReleaseNoteLocale (value: string): value is ReleaseNoteLocale {
	return [ 'cs', 'en' ].includes(value);
}

export function getReleaseNoteLocale (value: string): ReleaseNoteLocale | null {
	if (isReleaseNoteLocale(value)) { return value; }
	return null;
}

export function mapToCzechWeekday (id: number, localeString: string): number {
	const locale = getSupportedLocale(localeString);

	switch (locale) {
	case 'en':
		return (id + 6) % 7;
	default:
		return id;
	}
}
